<template>
  <div class="searchbox-container">
    <div class="searchbox-row col-lg justify-content-between">
      <label class="label" for="search-text">{{ $t('search.form.option') }}</label>
      <div class="d-flex">
        <input class="form-control d-flex-grow-1" id="search-text" type="search" v-model="searchTextNew" :aria-label="$t('search.form.option')" tabindex="0">
        <button class="btn btn-primary" 
                type="submit" id="search-button" v-on:click.prevent="handleClick">
          {{ $t('search.form.buttonText') }}
        </button>
      </div>
    </div>
    <div class="row no-gutters col-lg align-items-top justify-content-center">
      <section class="col-lg">
        <label class="label" for="search-app-status">{{ $t('search.form.applicationStatus') }}</label>
        <select class="form-control facets" v-model="searchAppStatus" id="search-app-status" @change="handleClick" >
          <option selected="true" value="activeOnly">{{ $t('search.form.activeDevAppText') }}</option> 
          <option value="inactiveOnly">{{ $t('search.form.inactiveDevAppText') }}</option> 
          <option value="all">{{ $t('search.form.allDevAppText') }}</option> 
        </select>
      </section>
      <section class="col-lg">
        <label class="label" for="search-app-type">{{ $t('search.form.applicationTypeText') }}</label>
        <select class="form-control facets" v-model="searchAppType" id="search-app-type" @change="handleClick" >
          <option selected="true" value="all">{{ $t('search.form.all') }}</option> 
          <option
            v-for="appType in appTypeSelections"
            class="app-type-option is-expanded"
            v-bind:value="appType.id"
            v-bind:key="appType.id"
          >{{ appType.name }}</option>
        </select>
      </section>
      <section class="col-lg">
        <label class="label" for="select-wards">{{ $t('search.form.wardText') }} 
          <span class="find-ward">
            (<a v-bind:href="$t('search.form.findWardLink')"
              id="find-ward-link"
              v-bind:aria-label="$t('search.form.findWardAriaLabel') + ' ' + $t('search.form.linkIsExternal')"
            >{{ $t('search.form.findWardText') }}</a> &nbsp;
              <span aria-hidden="true" class="icon is-medium">
                <svg aria-hidden="true" 
                  focusable="false" 
                  data-prefix="fas" 
                  data-icon="external-link-alt" 
                  role="img" 
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 512 512" class="svg-inline--fa fa-external-link-alt fa-w-16">
                  <path fill="currentColor" d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z" class=""></path>
                </svg>
              </span>) 
          </span>
        </label>
        <select class="form-control facets" id="select-wards" v-model="searchWards" @change="handleClick" >
          <option selected="true" value="all">{{ $t('search.form.all') }}</option> 
          <option
            v-for="ward in wardSelections"
            class="ward-option"
            v-bind:value="ward.id"
            v-bind:key="ward.id"
          >{{ ward.name }}</option>
        </select>
      </section>
    </div>
  </div>
</template>

<script>
import { fetchApplicationTypes, fetchWards } from '@/util/api'

const MIN_SEARCH_CHARS = 3

export default {
  name: 'search-box',
  data: function() {
    return {
      searchTextNew: '',
      wards: [],
      appTypes: [],
      searchAppStatus: 'activeOnly',
      searchAppType: 'all',
      searchWards: 'all',
    }
  },
  methods: {
    handleClick: function() {
      this.$store.commit('resetBounds')
      this.$store.commit('appStatus',this.searchAppStatus);
      this.$store.commit('appType',this.searchAppType);
      this.$store.commit('searchText', this.searchTextNew);
      this.$store.commit('ward', this.searchWards);
      this.$store.commit('searchIndex', 0)
      //console.log('SearchBox:handleClick', 'I am first')
      this.$emit('search-by-fields');
    },
    preLoadApplicationType: async function(){
      try {
        this.appTypes = await fetchApplicationTypes()
        console.log('preLoadApplicationType', 'Fetched!')
      } catch (e) {
        console.log('Error fetching data', e)
      }
    },
    preLoadWards: async function() {
      try {
        this.wards = await fetchWards()
        console.log('preLoadWards', 'Fetched!')
      } catch (e) {
        console.log('Error fetching data', e)
      }
    }
  },
  computed: {
    searchText: function() {
      return this.$store.state.searchText
    },
    enableSearchButton: function() {
      console.log('enableSearchButton', (this.searchTextNew.length >= MIN_SEARCH_CHARS))
      return (this.searchTextNew.length >= MIN_SEARCH_CHARS);
    },
    wardSelections: function() {
      let lang = this.$i18n.currentLanguage();
      let wardSelections = [];
      const wardPrefix = this.$t('search.results.wardPrefix');
      //console.log(this.wards)
      this.wards.forEach(ward => {
        let wardparts = [];
        if (ward.ward) {
          if (ward.ward === 'City Wide' || ward.ward === 'Multiple Wards') {
            wardparts.push(`${ward.ward}`);
          } else {
            wardparts.push(`${wardPrefix} ${ward.ward}`);
          }
        }
        if (lang === 'en' && ward.nameEN) {
          wardparts.push(ward.nameEN);
        }
        if (lang === 'fr' && ward.nameFR) {
          wardparts.push(ward.nameFR);
        }
        if (ward.councillor) {
          wardparts.push(ward.councillor);
        }
        //console.log('wardparts', wardparts)
        const wardName = wardparts.length > 2 ? wardparts.join(' - ') : wardparts.join ('');
        wardSelections.push({
          id: ward.id ? ward.id : '',
          name: wardName
        });
      });

      wardSelections.sort((a, b) => {
        const aKey = a.name
        const bKey = b.name
        if (aKey < bKey) { return -1 }
        if (aKey > bKey) { return 1 }
        return 0
      })

      return wardSelections;
    },
    appTypeSelections: function() {
      let lang = this.$i18n.currentLanguage();
      let appTypeSelections = [];
      this.appTypes.forEach(appType => {
        appTypeSelections.push({
          id: appType.id ? appType.id : '',
          name: appType.name[lang]
        });
      });
      const allOption = this.allOption;
      appTypeSelections.sort((a, b) => {
        const aName = a.name ? a.name : '';
        const bName = b.name ? b.name : '';
        if (aName === allOption) {
          return -1;
        }
        if (aName < bName) {
          return -1;
        }
        if (aName > bName) {
          return 1;
        }
        return 0;
      });
      return appTypeSelections;
    }
  },
  watch: {
    searchText: function() {
      this.searchTextNew = this.searchText
    },
  },
  created: function() {
    this.preLoadApplicationType()
    this.preLoadWards()
  },
}
</script>

<style scoped lang="scss">
@import '@/scss/app.scss';
</style>
